// extracted by mini-css-extract-plugin
export default {"feBody":"style_feBody__gmJ+G"};